<template>
  <Layout :style="{ minHeight: bodyHeight }">
    <Sider
      hide-trigger
      collapsible
      :collapsed-width="78"
      style="width: 255px; min-width: 255px"
    >
      <div class="side-logo">
        <img
          src="@assets/img/guoyao-logo2.png"
          alt="PCHI"
          @click="$router.push('/host/project')"
          class="f-csp"
        />
      </div>
      <gSide :siderArr="siderArr"></gSide>
    </Sider>
    <Layout
      style="height: 100%; width: calc(100% - 255px)"
      :style="{ minHeight: bodyHeight }"
    >
      <Header :style="{ padding: 0 }" class="layout-header-bar">
        <gHead></gHead>
      </Header>
      <Content>
        <div :style="{ minHeight: '500px' }">
          <router-view />
        </div>
      </Content>
      <Footer>
        <copyright />
      </Footer>
    </Layout>
  </Layout>
</template>

<script>
import gHead from "@components/gHead/gHead";
import gSide from "@components/gSide/gSide";
import copyright from "@components/copyright/copyright";
export default {
  name: "host-layout",
  data() {
    return {
      bodyHeight: "800px",
      siderArr: [
        {
          title: "首页",
          icon: "icon-shouye11",
          router: "/host/index/home",
          type: 1,
        },
        {
          title: "活动管理",
          icon: "icon-leimupinleifenleileibie",
          type: 2,
          children: [
            {
              title: "活动设置",
              router: "/host/index/ex/activitySet",
            },

            {
              title: "报名名单",
              router: "/host/index/ex/activityList",
            },
            {
              title: "参展申请",
              router: "/host/index/ex/applyEx",
            },
                        {
              title: "操作日志",
              router: "/host/index/ex/hostOperationLog",
            },
          ],
        },
        {
          title: "展会设置",
          icon: "icon-zhanhuiguanli",
          type: 2,
          children: [
            {
              title: "基础设置",
              router: "/host/index/set/base",
            },
            {
              title: "网上报名设置",
              router: "/host/index/set/onlineRegistration",
            },
          ],
        },
      ],
    };
  },
  components: {
    gHead,
    gSide,
    copyright,
  },
  computed: {},
  created() {
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
  },
};
</script>

<style lang="scss">
body {
  padding-right: 0 !important;
}
</style>
<style scoped lang='scss'>
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.side-logo {
  text-align: center;
  height: 64px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 35px;
    max-width: 98%;
    max-height: 98%;
  }
}
</style>
